import React from 'react';
import styles from './DropOffGuidelines.module.scss';
import { Container, Row } from 'reactstrap';

const DropOffGuidelines = () => {
    return (
        <div className={styles.mainContainer}>
            <h4 className={styles.sectionHeading}>Guidelines and Instructions</h4>
            <Container fluid className={styles.scheduleContainer}>
                <Row className={styles.scheduleRow}>
                    <h4 className={styles.sectionHeading}>General Guidelines</h4>
                    <ul>
                        <li>Ensure packages are labeled correctly</li>
                        <li>Arrive 10 minutes before the scheduled time</li>
                    </ul>
                </Row>
            </Container>
            <Container fluid className={styles.scheduleContainer}>
                <Row className={styles.scheduleRow}>
                    <h4 className={styles.sectionHeading}>Specific guidelines for Warehouse A</h4>
                    <ul>
                        <li>Use the north entrance</li>
                        <li>Park in the designated drop-off area</li>
                    </ul>
                </Row>
            </Container>
        </div>
    )
}

export default DropOffGuidelines;